import InsightItem from 'components/InsightItem';
import SegmentedBar from 'components/SegmentedBar';
import { useAtomValue } from 'jotai';
import React from 'react';
import { Card } from 'reactstrap';

import { findingsDataAtom, sourceTypeAtom } from './state';

const FindingInsights: React.FC = () => {
  const listingData = useAtomValue(findingsDataAtom);
  const insights = listingData?.insights;
  const sourceType = useAtomValue(sourceTypeAtom);

  const getAssetsLabel = () => {
    if (sourceType === 'sast') {
      return 'Repositories';
    } else {
      return 'Assets';
    }
  };

  const getUniqueVulnLabel = () => {
    if (sourceType === 'sast') {
      return 'Rule IDs';
    } else if (sourceType === '') {
      return 'Unique';
    } else {
      return 'QIDs';
    }
  };

  if (!listingData || !insights) {
    return <div>Loading...</div>; // Add a loading state
  }

  // Extract stats from insights
  const stats = {
    active: insights.active,
    new: insights.new,
    fixed: insights.fixed,
    reopened: insights.reopened,
    ignored: insights.ignored,
    urgent: insights.urgent,
    critical: insights.critical,
    serious: insights.serious,
    medium: insights.medium,
    minimal: insights.minimal,
    unique_assets: insights.unique_assets,
    watching_by_me_count: insights.watching_by_me_count,
    assigned_to_me_count: insights.assigned_to_me_count,
    unique_qids_or_rule_ids: insights.unique_qids_or_rule_ids,
  };

  return (
    <div className="container-fluid border border-light rounded p-0 mb-1">
      <Card
        className="mb-0 px-3 py-1"
        style={{ backgroundColor: 'rgba(34, 42, 66, 0.02)' }}
      >
        <div className="d-flex flex-wrap align-items-center">
          {/* Severity */}
          <div
            className="mr-2 pr-2 flex-grow-1 border-right"
            style={{ borderColor: '#dee2e6' }}
          >
            <h6 className="mb-0">Severity:</h6>
            <SegmentedBar
              height="5px"
              width="100%"
              segments={[
                {
                  color: 'urgent',
                  value: stats.urgent,
                  label: 'Urgent',
                },
                {
                  color: 'critical',
                  value: stats.critical,
                  label: 'Critical',
                },
                {
                  color: 'serious',
                  value: stats.serious,
                  label: 'Serious',
                },
                {
                  color: 'medium',
                  value: stats.medium,
                  label: 'Medium',
                },
                {
                  color: 'minimal',
                  value: stats.minimal,
                  label: 'Minimal',
                },
              ]}
              labelDisplay="value"
              tooltip={`Urgent: ${stats.urgent}, Critical: ${stats.critical}, Serious: ${stats.serious}, Medium: ${stats.medium}, Minimal: ${stats.minimal}`}
            />
          </div>

          {/* Count Summaries */}
          <InsightItem label="Active" value={stats.active} />
          <InsightItem label="New" value={stats.new} />
          <InsightItem label="Fixed" value={stats.fixed} />
          <InsightItem label="Reopened" value={stats.reopened} />
          <InsightItem label="Ignored" value={stats.ignored} />

          <InsightItem
            label={getUniqueVulnLabel()}
            value={stats.unique_qids_or_rule_ids}
            tooltip={
              sourceType === '' ? 'All Unique QIDs and Rule IDs' : undefined
            }
          />
          {stats.assigned_to_me_count > 0 && (
            <InsightItem label="Assigned" value={stats.assigned_to_me_count} />
          )}
          {stats.watching_by_me_count > 0 && (
            <InsightItem label="Watching" value={stats.watching_by_me_count} />
          )}
          <InsightItem
            label={getAssetsLabel()}
            value={stats.unique_assets}
            tooltip={
              sourceType === '' ? 'All Assets and Repositories' : undefined
            }
            isLast={true}
          />
        </div>
      </Card>
    </div>
  );
};

export default FindingInsights;
